import { isPrivate } from 'src/config/private';

export function customerReport(data) {
  // console.log('====customerReport====', data);
  // 私有化和本地不上报
  if (isPrivate || /^local/.test(window.location.hostname)) {
    return;
  }

  // 添加对错误信息的上报
  if (window.$qidianMonitor && window.$qidianMonitor.customerReport) {
    // name必填
    if (data.name) {
      window.$qidianMonitor.customerReport({ ...data });
    }
  }
}

export function formatReportErr(e, params) {
  const { code, status, message } = e || {};

  return JSON.stringify({ code, status, message, ...params });
}
